import { navLinks } from "@/mocks/home";

const genreLinks = ["科幻", "悬疑", "剧情", "动作", "都市", "动画", "武侠", "爱情"];

export default function Footer() {
  const jump = (id: string) => {
    const target = document.getElementById(id);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 68;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="max-w-content mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">神马电影网</span>
            </div>
            <p className="mt-4 text-sm text-background-200 leading-relaxed">
              围绕在线观看、免费观看、高清播放与极速观看整理的内容入口，兼顾无广告体验与蓝光画质说明，帮助你在同一页完成挑选与了解。
            </p>
          </div>

          <nav aria-label="页脚分区导航">
            <h3 className="font-heading text-base font-bold text-background-50">页面分区</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => jump(link.id)}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">题材分类</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {genreLinks.map((genre) => (
                <li key={genre}>
                  <button
                    type="button"
                    onClick={() => jump("browse")}
                    className="px-3 py-1 rounded-full bg-background-50/10 text-xs text-background-100 hover:bg-background-50/20 transition-colors cursor-pointer"
                  >
                    {genre}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">观看说明</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-hd-line mt-0.5 text-accent-400"></i>
                默认蓝光画质，可切换 4K HDR
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-400"></i>
                正片无广告，从片头直接开始
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-history-line mt-0.5 text-accent-400"></i>
                退出后自动记录播放进度
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-message-3-line mt-0.5 text-accent-400"></i>
                遇到异常内容可通过分区反馈说明了解处理方式
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300 text-center sm:text-left">
            © {new Date().getFullYear()} 神马电影网 · 本站内容用于展示在线观看、高清播放与极速观看相关信息
          </p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background-50/10 text-sm text-background-100 hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            返回顶部
          </button>
        </div>
      </div>
    </footer>
  );
}